import { Select , Row , Col , Button , Table , message , Form , Tag } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { loadingAction } from "../actions/loading-actions";
import { getActiveOperators, getBookingPartners, updateAllowedBookingOperators } from "../actions/booking-partners.actions";
import '../styles/booking-partners.style.scss';
import { isValid, isValidArray } from "../utils/utilities";
import { isQBUserCheck } from "../utils/constant";

const { Option } = Select;

export const BookingPartnersPage = () => {

    const dispatch = useDispatch();

    const isQBUser = isQBUserCheck();

    const [operators,setOperators] = useState([]);
    const [selectedOperator,setSelectedOperator] = useState(isQBUser?null:global.operatorCode);
    const [allowedOperatorCodes,setAllowedOperatorCodes] = useState([]);
    const [partners,setPartners] = useState([]);

    const setLoading=(bool)=>{
        dispatch(loadingAction(bool))
    }

    useEffect(()=>{
        getActiveOperators((operatorsInfo)=>{
            setOperators(operatorsInfo);
        },
        (errMsg)=>{
            message.error(errMsg);
        });
    },[]);

    useEffect(()=>{
        if(isValid(selectedOperator)){
            loadBookingPartners(selectedOperator);
        }else{
            setAllowedOperatorCodes([]);
            setPartners([]);
        }
    },[selectedOperator]);

    const loadBookingPartners=(operatorCode)=>{
        setLoading(true);
        getBookingPartners(operatorCode,(data)=>{
            setPartners(data);
            setAllowedOperatorCodes(data.map((partner)=>partner.operator_code));
            setLoading(false);
        },
        (errMsg)=>{
            message.error(errMsg);
            setLoading(false);
        });
    }

    const printOperatorOptions=(excludeOperatorCode)=>{
        let operatorOptions = [];
        if(isValidArray(operators)){
            operators.forEach((operator) => {
                if(operator.operator_code != excludeOperatorCode){
                    operatorOptions.push(
                        <Option key={operator.operator_code} value={operator.operator_code}>{operator.name}</Option>
                    );
                }
            });
        }
        return operatorOptions;
    }

    const onSave=()=>{
        if(!isValid(selectedOperator)){
            message.warning("Please select operator");
            return;
        }
        setLoading(true);
        updateAllowedBookingOperators(selectedOperator,allowedOperatorCodes,()=>{
            message.success("Booking partners updated successfully");
            loadBookingPartners(selectedOperator);
        },
        (errMsg)=>{
            message.error(errMsg);
            setLoading(false);
        });
    }

    return (
        <div className="booking-partners-root">
            <div className="booking-partners-inner-div">
                {isQBUser&&
                    <Row gutter={[16,16]} align="middle" className="booking-partners-row">
                        <Col>
                            <span className="font-weight-bold">Operator :</span>
                        </Col>
                        <Col>
                            <Select
                                placeholder="Select operator"
                                className="booking-partners-operator-selector"
                                value={selectedOperator}
                                showSearch
                                optionFilterProp="children"
                                onChange={(value)=>{
                                    setSelectedOperator(value);
                                }}
                            >
                                {printOperatorOptions(null)}
                            </Select>
                        </Col>
                    </Row>
                }
                <Row gutter={[16,16]} align="middle" className="booking-partners-row">
                    <Col>
                        <span className="font-weight-bold">Allowed operators (can book this operator's trips) :</span>
                    </Col>
                    <Col flex="auto">
                        <Select
                            mode="multiple"
                            placeholder="Select operators to allow"
                            className="booking-partners-multi-selector"
                            value={allowedOperatorCodes}
                            showSearch
                            optionFilterProp="children"
                            disabled={!isValid(selectedOperator)}
                            onChange={(values)=>{
                                setAllowedOperatorCodes(values);
                            }}
                        >
                            {printOperatorOptions(selectedOperator)}
                        </Select>
                    </Col>
                    <Col>
                        <Button type="primary" onClick={onSave} disabled={!isValid(selectedOperator)}>Save</Button>
                    </Col>
                </Row>
                {isValidArray(partners)&&partners.length>0&&
                    <Row>
                        <Col flex="auto">
                            <Table
                                dataSource={partners}
                                rowKey="operator_code"
                                columns={[
                                    {
                                        title:"Operator Name",
                                        dataIndex:'name',
                                        key:'name'
                                    },
                                    {
                                        title:"Operator Code",
                                        dataIndex:'operator_code',
                                        key:'operator_code'
                                    },
                                    {
                                        title:"Sharing Agent",
                                        dataIndex:'agent_user_name',
                                        key:'agent_user_name',
                                        render:(text)=>isValid(text)?text:'Created on save'
                                    },
                                    {
                                        title:"Agent Status",
                                        dataIndex:'agent_active',
                                        key:'agent_active',
                                        render:(text)=>{
                                            if(!isValid(text)&&text!=0){
                                                return <Tag>Not Created</Tag>;
                                            }
                                            return text==1?<Tag color="green">Active</Tag>:<Tag color="red">Inactive</Tag>;
                                        }
                                    }
                                ]}
                                pagination={false}
                            />
                        </Col>
                    </Row>
                }
            </div>
        </div>
    )
}
